import React from 'react';
import SmartiLabLayout from './SmartiLabLayout';
import { SmartiLabProvider } from './SmartiLabContext';

export default function SmartiLabDashboard({ currentUser }) {
  return (
    <SmartiLabProvider currentUser={currentUser}>
      <SmartiLabLayout />
    </SmartiLabProvider>
  );
}
